import $ from "jquery";
import moment from "moment";
import "zebra_datepicker";
import { Klass, u_ } from "@pressmedia/webappbase";
import "@pressmedia/vuwform/src/assets/jquery.mask.customize";

const device = Klass("Console").device;

export default {
	// [ボタンの設定]
	buttonText: {
		clear: {
			txt: "クリア",
			exp: "全件表示の条件に戻します"
		},
		submit: {
			txt: "検索",
			exp: "データの絞り込みを実行します"
		}
	},
	
	/**
	 * ボタンの作成
	 * @returns {$Object}
	 */
	_createFuncParts() {
		return $.fn.append.apply(
			$("<div/>").addClass("func-area"),
			Object.keys(this.buttonText).map(k => {
				const data = this.buttonText[k];
				const $btn = $("<a/>").addClass(`btn btn-${k}`).attr("href", "./").append(
					$("<span/>").text(data.txt)
				);
				!!data.exp && $btn.attr("title", data.exp);
				return $btn;
			})
		);
	},
	
	/**
	 * フォームの中身の生成
	 *
	 * @param {Object} config
	 * @returns this
	 */
	initForm(config) {
		if( !u_.isObject(config) ) {
			throw new TypeError("initFrom(): arguments[0] must be object.");
		}
		
		// 内部変数に検索パラメータを保持
		this.searchParams = u_.isObject(config.search) ? config.search : {};
		
		u_.isObject(config.dataParams) || (config.dataParams = {});
		const dataParams = { ...config.dataParams };
		
		// 必ず持っている項目
		!dataParams.itemId && (dataParams.itemId = {
			name: "ID",
			inpType : "text"
		});
		!dataParams.dateUpd && (dataParams.dateUpd = {
			name: "更新日",
			inpType : "datetime"
		});
		
		
		// **** init inps list ****
		const inpTypeMap = this._initInpsList(dataParams);
		if(!inpTypeMap) {
			return this;
		}
		
		// **** attach Plugin ****
		if( u_.isFunction($.fn.mask) ) {
			// [mask]
			this.$self.find(".inp-num").each((i, inp) => {
				const $inp = $(inp);
				const mask = String( $inp.data("mask") );
				if(typeof mask === "string") {
					$inp.mask(mask, {placeholder: mask});
				}
			});
			
			// ID検索
			let idLength = config.idLength || 6;
			if(dataParams.itemId.ltd) {
				idLength = dataParams.itemId.ltd;
			}
			$("#fltr_itemId").mask( u_.zeroPadding(0, idLength) );
		}
		
		if(device[0] === "pc" && u_.isFunction($.fn.Zebra_DatePicker) ) {
			this._attachZebraDatePicker();
		}
		
		
		// [period - period]
		if( Array.isArray(inpTypeMap.period) ) {
			const l = inpTypeMap.period.length;
			for(let i = 0; i < l; i++) {
				const pk = inpTypeMap.period[i];
				const pi = dataParams[pk];
				if(pi.inpType === "period") {
					// period-config向けのイベントリスナーを登録
					this._addEventListenerForPeriodConfig();
					break;
				}
			}
		}
		
		// [for filterOffMode]
		this.$self.attr("data-filter-off-mode", this.filterOffMode ? "1" : "0");
		
		// filterOffMode: trueの場合、各項目ごとにフィルタが有効になっているかどうかを判定する
		if(this.filterOffMode) {
			this._addEventListenerForFilterOffMode();
		}
		
		// **** init func parts ****
		this._createFuncParts().appendTo(this.$self);
		
		this.config = config;
		
		return this;
	},
	
	/**
	 * 入力リストを生成
	 * @param {Object} config
	 * @returns {Object} inpTypeMap: 入力タイプごとのキー配列
	 */
	_initInpsList(dataParams) {
		const keys = Object.keys(this.searchParams);
		if(!this.$self || !keys.length) {
			return false;
		}
		
		const grid = {
			s: {
				conf: {
					s: 1, m: 1, l: 2, f: 2
				},
				count: 0
			},
			w: {
				conf: {
					s: 1, m: 2, l: 3, f: 4
				},
				count: 0
			}
		};
		
		const inpTypeMap = {};
		
		$.fn.append.apply(
			$("<ul/>").addClass("inps-list").attr("data-style", "grid"),
			keys.map(pk => {
				const sPi = this.searchParams[pk] || {};
				const pi = dataParams[pk] || {};
				
				// set
				!sPi.inpType && (sPi.inpType = (pi && pi.inpType) ? pi.inpType : "text");
				!sPi.inpSize && (sPi.inpSize = "f");
				
				Array.isArray(inpTypeMap[sPi.inpType]) || (inpTypeMap[sPi.inpType] = []);
				inpTypeMap[sPi.inpType].push(pk);
				
				// init param name block
				const $pn = $("<div/>").addClass("pn");
				if(pk === "KEYWORD") {
					const targets = sPi.target.map(target => dataParams[target].name).join(", ");
					$pn.append(
						$("<span/>").text(this.keywordDisp),
						$("<span/>").addClass("limit").text(`（${targets}から検索します）`)
					);
					
				} else {
					$pn.append( $("<span/>").text(pi.name) );
				}
				
				// init param param data block
				const $pd = this._createInputParts(pk, sPi.inpType, pi).addClass("pd");
				
				// calc grid
				(grid.s.count + grid.s.conf[sPi.inpSize] > grid.s.conf.f) && (grid.s.count = 0);
				(grid.w.count + grid.w.conf[sPi.inpSize] > grid.w.conf.f) && (grid.w.count = 0);
				
				// init param block
				const $param = $("<li/>").addClass(`param-${pk} size-${sPi.inpSize}`).attr({
					"data-gridSpLeft": !!grid.s.count ? 0 : 1,
					"data-gridPcLeft": !!grid.w.count ? 0 : 1
				}).append($pn, $pd);
				!!this.filterOffMode && $param.addClass("hover-target");
				
				grid.s.count += grid.s.conf[sPi.inpSize];
				grid.w.count += grid.w.conf[sPi.inpSize];
				
				return $param;
			})
		).appendTo(this.$self);
		
		return inpTypeMap;
	},
	
	/**
	 * Zebra_DatePickerの適用
	 * @returns this
	 */
	_attachZebraDatePicker() {
		// Zebra_DatePicker
		this.$self.find(".inp-date").Zebra_DatePicker({
			format: "Y-m-d",
			days: moment.weekdaysShort(),
			months: moment.months(),
			header_captions: {
				"days": "Y年F",
				"months": "Y年",
				"years": "Y1 - Y2年"
			},
			first_day_of_week: 0,
			select_other_months: false,
//				direction: [false, moment().format("YYYY-MM-DD")],		// 今日以前のみ選択可能
			default_position: "below",
			offset: [8, -88],
			show_icon: false,						//アイコン非表示
			show_clear_date: true,			//クリアボタン表示
			lang_clear_date: "クリア",
			show_select_today: false,		//「今日」ボタン非表示
			
			onClear() {
				this.data("Zebra_DatePicker").settings.onSelect.call(this, "");
			},
			
			onSelect() {
				this.trigger("change", [false, "datePicker"]);
			}
		})
		
		// 対応する日付のカレンダーピッカーの表示を動的に変更する
		.each((i, inp) => {
			const keys = inp.id.split("_");
			if(keys[keys.length - 1] !== "from") {
				return true;
			}
			
			keys.splice(keys.length - 1, 1, "to");
			const period = {
				$f: $(inp),
				$t: $(`#${keys.join("_")}`)
			};
			
			if(period.$t.length) {
				period.$f.data("pair", period.$t).data("Zebra_DatePicker").update({
					onSelect(val) {
						if( !val || !this.data("pair").val() ) {
							this.data("pair").data("Zebra_DatePicker").update({
								start_date: val
							});
						}
						this.trigger("change", [false, "datePicker"]);
					}
				});
				
				period.$t.data("pair", period.$f).data("Zebra_DatePicker").update({
					onSelect(val) {
						if( !val || !this.data("pair").val() ) {
							this.data("pair").data("Zebra_DatePicker").update({
								start_date: val
							});
						}
						this.trigger("change", [false, "datePicker"]);
					}
				});
			}
		});
		
		return this;
	}
}
